module.exports = __webpack_public_path__ + "static/dei-logo-1bef377a1585fc9304b5505d7c1c2ea1.png";